import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AdminRents.css";
function AdminRents() {
  const navigate = useNavigate();

  return (
    <div className="rents-layout">

        <div className="rents-sidebar">
          <h2 className="rents-logo">🏠 RealEstate</h2>

          <ul>
             <li onClick={() => navigate("/admin/dashboard")}>Dashboard</li>
             <li onClick={() => navigate("/admin/properties")}>Properties</li>
             <li onClick={() => navigate("/admin/buys")}>Buys</li>
             <li onClick={() => navigate("/admin/sales")}>Sales</li>
             <li className="active-rents">Rents</li>
             <li onClick={() => navigate("/admin/messages")}>Messages</li>
             <li onClick={() =>navigate("/admin/settings")}>Settings</li>
           </ul>
        </div>

      <div className="rents-container">
        <div className="rents-topbar">Rents Page</div>

         <h2>Rents</h2>
          <p> No rent leads yet</p>
        </div>
       </div>
  );
}

export default AdminRents;